jQuery('.customer a').click(function() {
    var customer_id = jQuery(this).attr('data-id');
    jQuery.get(
        ajaxurl,
        {
            'action': 'customer',
            'data': {'id': customer_id}
        }).done(function (data) {
        jQuery("#customer-popup img").attr('src' , '');
        jQuery("#customer-popup h4").empty();
        jQuery("#customer-popup .customer-blocks").empty();

        jQuery("#customer-popup img").attr('src' , data['thumbnail']);
        jQuery("#customer-popup h4").html('"' + data['text'] + '"');
        jQuery("#customer-popup .customer-title").html(data['name']);
        jQuery("#customer-popup .customer-description").html(data['title']);
        jQuery("#customer-popup .customer-blocks").html(data['blocks']);
        jQuery('#ModalCustomers').modal('show');
    });
});
